<template>
    <div>
        <el-row :gutter="10" v-if="IsEdit">
            <el-col :span="1.5">
                <el-button size="mini" @click="handleAdd">新增</el-button>
            </el-col>
        </el-row>

        <el-table v-loading="loading" :data="warnRuleList" style="margin-top: 15px;">
            <el-table-column label="序号" width="60" type="index" align="center" prop="no"></el-table-column> 
            <el-table-column label="预警级别" align="center" prop="warnLevelTranslated"></el-table-column>
            <el-table-column label="颜色" align="center" prop="warnColorTranslated"></el-table-column>
            <el-table-column label="比较方式" align="center" prop="compareTypeTranslated"></el-table-column>
            <el-table-column label="数值" align="center" prop="warnNum" />
            <el-table-column label="操作" align="center" width="120px" class-name="small-padding fixed-width" v-if="IsEdit">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="text"
                        @click="handleView(scope.row)"
                    >查看</el-button>
                    <el-button
                        size="mini"
                        type="text"
                        @click="handleUpdate(scope.row)"
                    >编辑</el-button>
                    <el-button
                        size="mini"
                        type="text"
                        @click="handleDelete(scope.row)"
                    >删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            v-show="total>0"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.pageNum"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="queryParams.pageSize"  
            layout="total, sizes, prev, pager, next, jumper"
            background
        ></el-pagination>

        <!-- 添加/修改预警规则 -->
        <el-dialog title="编辑预警规则" :visible.sync="open" width="450px" append-to-body>
            <el-form ref="rulesForm" :model="rulesForm" :rules="rules" label-width="80px">
              <el-form-item label="预警级别" prop="warnLevel">
                  <el-select v-model="rulesForm.warnLevel" placeholder="请选择预警级别" style="width: 200px;">
                      <el-option
                          v-for="dict in dict.type.warn_level"
                          :key="dict.value"
                          :label="dict.label"
                          :value="dict.value"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="颜色" prop="warnColor">
                  <el-select v-model="rulesForm.warnColor" placeholder="请选择颜色" style="width: 200px;">
                      <el-option
                          v-for="dict in dict.type.warn_color"
                          :key="dict.value"
                          :label="dict.label"
                          :value="dict.value"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="比较方式" prop="compareType">
                  <el-select v-model="rulesForm.compareType" placeholder="请选择比较方式" style="width: 200px;">
                      <el-option
                          v-for="dict in dict.type.warn_compare_type"
                          :key="dict.value"
                          :label="dict.label"
                          :value="dict.value"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="数值" prop="warnNum">
                  <el-input type="number" v-model="rulesForm.warnNum" placeholder="请输入数值" style="width: 200px;"/>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </el-dialog>
	
        <!-- 查看预警规则 -->
        <el-dialog title="查看预警规则" :visible.sync="look" width="400px">
            <el-form ref="rulesForm" :model="rulesForm" label-width="120px" size="mini">
                <el-row>
                    <el-form-item label="预警级别：">{{ rulesForm.warnLevelTranslated }}</el-form-item>
                    <el-form-item label="颜色：">{{ rulesForm.warnColorTranslated }}</el-form-item>
                    <el-form-item label="比较方式：">{{ rulesForm.compareTypeTranslated }}</el-form-item>
                    <el-form-item label="数值：">{{ rulesForm.warnNum }}</el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="close">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { listWarnRule, getWarnRuleById, addWarnRule, updateWarnRule, delWarnRule } from '@/api/src/warnRule'
export default {
    name: "WarnRule",
    dicts: [
        'warn_level',
        'warn_color',
        'warn_compare_type'
    ],
    props: {
        warnConfigId: {
            type: Number,
            default: null,
        },
        IsEdit: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 总条数
            total: 0,
            // 报文模板表格数据
            warnRuleList: [],
            // 是否显示弹出层
            open: false,
            look: false,
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 5,
                warnConfigId:this.warnConfigId || null
            },
            // 表单参数
            rulesForm: {
                warnConfigId:this.warnConfigId || null
            },
            // 表单校验
            rules: {
                warnLevel: [
                    { required: true, message: "请选择预警级别", trigger: "change" },
                ],
                warnColor: [
                    { required: true, message: "请选择颜色", trigger: "change" },
                ],
                compareType: [
                    { required: true, message: "请选择比较方式", trigger: "change" },
                ],
                warnNum: [
                    { required: true, message: "请输入数值", trigger: "blur" },
                ]
            }
        };
    },
    created() {
        this.getList();
    },
    methods: {
        // 查询
        getList() {
            this.loading = true;
            listWarnRule(this.queryParams).then(response => {
                this.warnRuleList = response.rows;
                this.total = response.total;
                this.loading = false;
            });
        },
        // 表单重置
        reset(){
            this.rulesForm = {
                warnConfigId:this.warnConfigId || null,
                warnLevel: null,
                warnColor: null,
                compareType: null,
                warnNum: null,
            },
            this.resetForm("rulesForm");
        },
        // 添加预警规则
        handleAdd() {
            this.reset();
            this.open = true;
        },
        // 编辑预警规则
        handleUpdate(row) {
            this.reset();
            getWarnRuleById(row.id).then(response => {
                this.rulesForm = response.data;
                this.open = true;
            });
        },
        // 查看预警规则
        handleView(row) {
            this.look = true;
            this.rulesForm = row;
        },
        // 保存
        submitForm() {
            this.$refs["rulesForm"].validate(valid => {
                if (valid) {
                    if (this.rulesForm.id != null) {
                        updateWarnRule(this.rulesForm).then(response => {
                            this.$message({type: "success", message: "修改成功!"});
                            this.open = false;
                            this.getList();
                        });
                    } else {
                        addWarnRule(this.rulesForm).then(response => {
                            this.$message({type: "success", message: "新增成功!"});
                            this.open = false;
                            this.getList();
                        });
                    }
                }
            });
        },
        // 删除
        handleDelete(row) {
            this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(function() {
                return delWarnRule(row.id);
            }).then(() => {
                this.$message({type: "success", message: "删除成功!"});
                this.getList();
            }).catch(() => {});
        },
        // 取消按钮
        cancel() {
            this.open = false;
        },
        // 查看的关闭按钮
        close(){
            this.look = false;
        },
        // 点击每页显示的条数
        handleSizeChange(val){
            this.queryParams.pageSize = val;
            this.getList();
        },
        // 点击切换到某页
        handleCurrentChange(val){
            this.queryParams.pageNum = val;
            this.getList();
        }
    }
  };
</script>
<style scoped>
::v-deep .el-pagination{
    padding: 10px 5px;
    position: relative;
    float: right;
}
::v-deep .el-dialog__body{
    padding: 10px 20px;
}
::v-deep .el-dialog > div:not(:first-child).el-dialog__body{
    padding-top: 30px;
}
</style>